import React, { useState } from "react";
import styles from "./Contact.module.css";
import whatsappicon from "assets/whatsappicon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Turnstile } from "@marsidev/react-turnstile"; // ✅ Turnstile import
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [purpose, setPurpose] = useState("");
  const [otherPurpose, setOtherPurpose] = useState("");
  const [turnstileToken, setTurnstileToken] = useState(""); // ✅ store captcha token
  const [captchaError, setCaptchaError] = useState("");

  const handlePurposeChange = (e) => {
    setPurpose(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      setCaptchaError("Please complete the CAPTCHA.");
      return;
    }

    const formData = new FormData(e.target);
    const finalPurpose =
      formData.get("purpose") === "Other"
        ? `Other: ${formData.get("otherPurpose") || ""}`
        : formData.get("purpose");

    const payload = {
      name: formData.get("name"),
      email: formData.get("email"),
      phoneNumber: formData.get("phoneNumber"),
      purpose: finalPurpose,
      message: formData.get("message"),
      turnstileToken, // ✅ send token to backend
    };

    setLoading(true);
    try {
      const response = await fetch(`https://ds3s15234f.execute-api.ap-south-1.amazonaws.com/dev/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(
          data.message || "Your message has been sent successfully!"
        );
        e.target.reset();
        setPurpose("");
        setOtherPurpose("");
        setTurnstileToken("");
      } else {
        toast.error(
          data.message || "Failed to send message. Please try again."
        );
      }
    } catch (err) {
      console.error("❌ Error submitting form:", err);
      toast.error("There was an error submitting your message.");
    } finally {
      setLoading(false);
    }
  };

  const redirectToWhatsApp = () => {
    const phoneNumber = "+918123870326";
    const message = encodeURIComponent("Hello, I would like to chat with you!");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <div className={styles.boxOne}>
          <h1 className={styles.heading}>
            Estimations & Planning For
            <br />
            <span style={{ color: "#0B93D4" }}> Business Decisions</span>
          </h1>
          <p className={styles.paragraph}>
            We are a Digital Product Engineering company that is scaling in a
            big way! We build products, services, and experiences that inspire,
            excite, and delight.
          </p>
          <button onClick={redirectToWhatsApp} className={styles.btn}>
            <img className={styles.btnImg} src={whatsappicon} alt="WhatsApp" />
            <span>We are always excited to chat!</span>
          </button>
        </div>

        <div className={styles.boxTwo}>
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                className={styles.name}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                className={styles.email}
                required
              />
            </div>

            <div className={styles.formGroup}>
              <input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number / Whatsapp"
                className={styles.num}
                required
              />
            </div>

            {/* ✅ Purpose Dropdown (unchanged) */}
            <div className={styles.formGroup}>
              <select
                name="purpose"
                className={styles.email}
                value={purpose}
                onChange={handlePurposeChange}
                required
              >
                <option value="">Select Purpose</option>
                <option value="Hire Talent">Hire Talent</option>
                <option value="Join Team">Join Team</option>
                <option value="Partnership">Partnership</option>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {/* ✅ “Other Purpose” field shown only if selected */}
            {purpose === "Other" && (
              <div className={styles.formGroup}>
                <input
                  type="text"
                  name="otherPurpose"
                  placeholder="Please specify your purpose"
                  className={styles.email}
                  value={otherPurpose}
                  onChange={(e) => setOtherPurpose(e.target.value)}
                  required
                />
              </div>
            )}

            <div className={styles.formDes}>
              <label>How can we help your business?</label>
              <textarea name="message" required />
            </div>

            {/* ✅ Turnstile CAPTCHA instead of math */}
            <div style={{ margin: "10px 0" }}>
              <Turnstile
                siteKey={"0x4AAAAAAB_TvBQU7q63Kawb"
                }
                onSuccess={(token) => {
                  setTurnstileToken(token);
                  setCaptchaError("");
                }}
                onError={() => {
                  setTurnstileToken("");
                  setCaptchaError("CAPTCHA validation failed. Try again.");
                }}
              />
              {captchaError && (
                <p style={{ color: "red", fontSize: "13px", marginTop: "5px" }}>
                  {captchaError}
                </p>
              )}
            </div>

            <button
              className={styles.submitButton}
              type="submit"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
